import { Monitorings } from '@factorin/domain';

import { get, withUrl } from '../rest';


const monitoringPart = withUrl('monitoring');

export const monitoring = {
    list: get<void, Monitorings.Monitoring[]>(
        () => monitoringPart(),
    ),
};
